module.exports = __webpack_public_path__ + "static/media/podcast.b6481741.jpg";